

<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title class="mb-1">
          {{ $t(this.title) }}
        </b-card-title>
      </div>
    </b-card-header>

    <b-card-body>
      <b-row>

        <b-col sm="12" md="12" ml="12" lg="12" xl="7"    > 
          <vue-apex-charts ref="barChart" type="bar" height="300" :options="apexChatData.lineChartSimple.chartOptions"
            :series="barSeries" />
        </b-col>
        <b-col sm="12" md="12"  lg="12"   xl="5"  class="dount-div"   >
          <vue-apex-charts ref="donutChart" type="donut" height="300" :options="donutChart.chartOptions"
            :series=donut_series />
        </b-col>
      </b-row>



    </b-card-body>
  </b-card>
</template>

<script>

import { $themeColors } from '@themeConfig'

import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge, BRow,
  BCol,
} from 'bootstrap-vue'

import { ref, computed } from '@vue/composition-api'

import VueApexCharts from 'vue-apexcharts'
import store from '@/store'

// colors
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#FF977E',
    series2: '#FF0000',
    series3: '#8cc698',
    series4: '#2b9bf4',
    series5: '#757575',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}

export default {

  props: ['barSeries', 'labels', 'title', 'donut_series', 'donut_labels'],
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BRow,
    BCol,
  },

  watch: {
    '$store.state.appConfig.layout.isRTL': function (newVal, oldVal) {

      // console.log('old',this.$t('Total'))
      this.$t('Total')
      this.$refs.barChart.updateOptions({
        xaxis: {
          categories: [this.$t('Total'), this.$t('Working')]
        },
        legend: { customLegendItems: [this.$t('Total'), this.$t('Working')] }
      })


      //legend:{  customLegendItems:[this.$t('Total'),this.$t('Working')]}

      //this.$refs.donutChart.forceUpdate();
      this.$refs.donutChart.updateOptions({
        legend: { customLegendItems:[this.$t('offline'), this.$t('stopped') , this.$t('working')] },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                // total: {
                //   show: true,
                //   fontSize: '1em',
                //   label: this.$t('Total'),
                // }

              }
            }
          }
        }
      });


    }

  },


  data() {
    return {
      isRtl: this.$store.state.appConfig.layout.isRTL,
      donutChart: {

        chartOptions: { 

          
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '0.5rem',
            fontFamily: 'Montserrat',
          
            customLegendItems: [this.$t('offline'), this.$t('stopped') , this.$t('working')]
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          
          dataLabels: {
            offset: 2,
            enabled: true,
            position: 'end',
            style: {
              fontSize: '11px',
              fontWeight: 'bold',
              marginTop: '4px'


            },
            formatter(val) {
              // eslint-disable-next-line radix
             // console.log(globals.seriesTotals[0)
              return `${parseInt(val)}%`
            },
  //           formatter: function(value, { seriesIndex, dataPointIndex, w }) {

  //             console.log( w.config.series)
  //             return  (w.config.series[1]/w.config.series[0])
  //  // return w.config.series[seriesIndex].name + ":  " + value
  // }
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`
                    },
                  },
                  total: {
                    show: false,
                    fontSize: '.5em',
                    label: this.$t('Total'),


                    formatter(w) {
                      return `${w.globals.seriesTotals[0]}`;
                    },
                  },
                },
              },
            },
          },
          labels: [this.$t('offline'), this.$t('stopped'),this.$t('working')], //this.donut_labels,
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                   
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                stroke: {
                  show: true,
                  curve: 'smooth',
                  lineCap: 'butt',
                  colors: undefined,
                  width: 16,
                  dashArray: 10,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem',
                        },
                        value: {
                          fontSize: '1rem',
                        },
                        total: {
                          fontSize: '1rem',
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
      apexChatData: {
        lineChartSimple: {

          chartOptions: {
            legend: {
              show: true,
              position: 'bottom',
              fontSize: '0.5rem',
              fontFamily: 'Montserrat',
              customLegendItems: [this.$t('Total'), this.$t('Working')]

            },
            chart: {
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
            },
            markers: {
              strokeWidth: 2,
              strokeOpacity: 1,
              strokeColors: [$themeColors.light],
              colors: [$themeColors.light],
            },
            colors: [$themeColors.warning, $themeColors.primary],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'straight',
              
            },
            grid: {
              xaxis: {
                lines: {
                  show: true,
                },
              },
            },
            // tooltip: {
            //   custom(data) {
            //     return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
            //       }%</span></div>`
            //   },
            // },
            xaxis: {
              categories: this.labels,
            },
            yaxis: {
              opposite: this.$store.state.appConfig.isRTL
            },
          },
        },
      }
    }
  },
}
</script>

<style scoped>
.dount-div{
 box-shadowx: rgba(9, 30, 66, 0.03) 0px 4px 8px -2px, rgba(9, 30, 66, 0.03) 0px 0px 0px 1px;
  padding-top: 1.5rem;
  min-width: 11rem;
}
</style>
